import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
      </div>
      <div className="descriptionbox-description">
        <p>
      <p>
    Welcome to NepliShop – your destination for trendy, quality fashion at affordable prices. 
    Discover stylish shoes, shirts, and pants for every occasion. 
    Shop with confidence, enjoy with style.
</p>
          </p>
      </div>
    </div>
  )
}

export default DescriptionBox
